import { render, staticRenderFns } from "./goodsorder.vue?vue&type=template&id=21e4b1db&scoped=true"
import script from "./goodsorder.vue?vue&type=script&lang=js"
export * from "./goodsorder.vue?vue&type=script&lang=js"
import style0 from "./goodsorder.vue?vue&type=style&index=0&id=21e4b1db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4b1db",
  null
  
)

export default component.exports